export default {
  SET_LOADED(state, payload) {
    state.loaded = payload;
  },
  SET_SCORE(state, payload) {
    state.score = payload;
  },
  SET_LIFE(state, payload) {
    state.life = payload;
  },
  SET_MT(state, payload) {
    state.mt = parseInt(payload, 10);
  },
  SET_LEVEL(state, payload) {
    state.level = payload;
  },
  SET_INTRO_DONE(state, payload) {
    state.introDone = payload;
  },
  SET_GAME_LOADING(state, payload) {
    state.isGameLoading = payload;
  },
  SET_PLAY_GAME(state, payload) {
    state.isGamePlaying = !payload;
  },
  SET_SHOW_PAUSE(state, payload) {
    state.showPause = payload;
  },
  SET_GAMEOVER(state, payload) {
    state.isGameOver = payload;
  },
  SET_POWER_UP_PERCENTAGE(state, payload) {
    state.powerUpPercentage = payload;
  },
  SET_USER_DATA(state, payload) {
    state.userData = payload;
    if (state.userData.score > 0) state.tutorial = 3;
  },
  SET_CHARACTER_SELECTION(state, payload) {
    state.characterSelection = payload;
  },
  SET_CHARACTER(state, payload) {
    state.characterId = payload;
  },
  SET_TUTORIAL(state, payload) {
    state.tutorial = payload;
  },
};
